// extracted by mini-css-extract-plugin
export var avatarContainer = "_et-0";
export var avatarTypingWave = "_et-i";
export var gray = "_et-f";
export var green = "_et-c";
export var icon = "_et-9";
export var image = "_et-1";
export var lg = "_et-6";
export var md = "_et-5";
export var presenceDot = "_et-b";
export var red = "_et-d";
export var sm = "_et-4";
export var status = "_et-a";
export var typingDot = "_et-h";
export var typingPill = "_et-g";
export var xl = "_et-7";
export var xs = "_et-3";
export var xxl = "_et-8";
export var xxs = "_et-2";
export var yellow = "_et-e";